import { t } from '@lingui/core/macro';
import { SidebarLoader } from 'app/domains/documents/SidebarLoader';
import { PollingState } from '../PollingState';
export function CancellingState(props) {
    const { polling = true } = props;
    const title = t({
        message: 'Cancelling e-signing',
        comment: 'Message when the document sent for for e-signing is being cancelled',
    });
    const message = t({
        message: 'Waiting for the e-signing provider. This may take a moment.',
        comment: 'Descriptive message when the document sent for for e-signing is being cancelled',
    });
    if (polling) {
        return <PollingState title={title} message={message}/>;
    }
    return <SidebarLoader title={title} message={message}/>;
}
